(function($) {
  // Populates a select drop-down with options in a list 
  $.fn.populate = function(list) {
    this.append($('<option>'));
    return this.append(list.map(item => $('<option>', {
      text  : item.text,
      value : item.value
    })));
  };
})(jQuery);